import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=6217b0e4"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6217b0e4')) {
      api.createRecord('6217b0e4', component.options)
    } else {
      api.reload('6217b0e4', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=6217b0e4", function () {
      api.rerender('6217b0e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/sidebar/Sidebar.vue"
export default component.exports